module.exports = __webpack_public_path__ + "img/signup-carousel-third.120c4665.png";